<template>
  <ax-dialog ref="dialog"
             mode="listitem"
             :title="group.name"
             linkText="Group details"
             :subtitle="`${group.count} wells`"
             icon="mdi-information-outline"
             tooltip="Group details"
             size="medium">
    <template slot="content">
      <v-card-text>
        <pre>{{ group }}</pre>
      </v-card-text>
    </template>
  </ax-dialog>
</template>
<script>
import AxDialog from '@/components/dialog'
export default {
  name: "dlgGroupInfo",
  props: {
    group: { type: Object, required: true },
  },
  components: {
    AxDialog
  },
  computed: {
    groupParams() {
      if (!this.group) return {}
      if (!('params' in this.group)) return {}
      if (this.isEmpty(this.group.params[this.group.target])) return {}
      return this.group.params[this.group.target]
    },
    groupCurves() {
      if (!this.group) return {}
      if (!('curves' in this.group)) return {}
      if (!(this.group.target in this.group.curves)) return {}
      if (this.isEmpty(this.group.curves[this.group.target])) return {}
      return this.group.curves[this.group.target]
    },
  }
}
</script>
